var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShibaInu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-shibainu"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shibainu",
    clipPath: "url(#clip-shibainu)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_51",
    "data-name": "Layer 51",
    transform: "translate(-2.654 -2.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(2.654 2.654)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 30,
    height: 30,
    rx: 7,
    fill: "#ff2424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M0,7A7,7,0,0,1,7,0h6.49A16.337,16.337,0,0,1,14.3,5.108,16.351,16.351,0,0,1,0,21.33Z",
    transform: "translate(0 0)",
    fill: "#ff4545"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(8.733 8.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931",
    transform: "translate(3.543 8.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8575",
    "data-name": "Path 8575",
    d: "M294.921,238.063a1.019,1.019,0,0,1-.294.3,5.079,5.079,0,0,1-1.933.729,2.373,2.373,0,0,1-1,.028c-.085-.043-.1-.076-.067-.185a1.472,1.472,0,0,1,.593-.711c.164-.119.83-.523,1.14-.694a4.025,4.025,0,0,1,1.2-.487.622.622,0,0,1,.228,0c.055.021.115.183.14.378A5,5,0,0,1,294.921,238.063Z",
    transform: "translate(-284.386 -237.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8576",
    "data-name": "Path 8576",
    d: "M180.394,239.525a.33.33,0,0,1-.212.091,3.43,3.43,0,0,1-.6-.015,6.288,6.288,0,0,1-1.828-.526,2.3,2.3,0,0,1-.63-.422l-.085-.088-.009-.116a3.207,3.207,0,0,1,.012-.63.821.821,0,0,1,.095-.268c.024-.03.024-.03.134-.03a1.307,1.307,0,0,1,.428.079,8.353,8.353,0,0,1,1.608.8,2.788,2.788,0,0,1,.93.723C180.348,239.266,180.423,239.464,180.394,239.525Z",
    transform: "translate(-177.019 -237.489)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8577",
    "data-name": "Path 8577",
    d: "M232.856,294.013c0,.009-.036.155-.082.328s-.082.315-.082.319a.5.5,0,0,1-.1,0h-.1l-.134.315c-.073.173-.139.334-.149.359l-.018.042-.063-.1-.063-.1v-.842l-.025.006c-.052.012-.419.063-.58.076a8.265,8.265,0,0,1-2-.043,1.975,1.975,0,0,0-.2-.024s0,.2.006.438l.009.431-.052.079c-.027.043-.055.079-.055.083a.674.674,0,0,1-.109-.18,2.017,2.017,0,0,1-.17-.462l-.021-.088-.094.006-.095.009-.024-.112c-.013-.063-.028-.155-.033-.207l-.009-.1-.08-.071c-.046-.04-.091-.079-.1-.085a.067.067,0,0,1-.021-.052V294l.378,0,.378,0,.012.039.013.04.131.006.511.015.378.009.1-.152.1-.152h.126V293.5l0-.315-.167-.072a1.63,1.63,0,0,1-.972-.836,1.152,1.152,0,0,1-.031-.395,1.186,1.186,0,0,1,.018-.4.441.441,0,0,1,.315-.31,7.287,7.287,0,0,1,.905-.015l.845,0,.095.045a.53.53,0,0,1,.228.18.5.5,0,0,1,.095.359,2.641,2.641,0,0,1-.046.583,1.245,1.245,0,0,1-.176.349,1.618,1.618,0,0,1-.681.477l-.073.027,0,.32,0,.319.067.006.067.006.091.137.088.137h.407c.225,0,.422,0,.441.006s.037,0,.067-.049l.037-.054h.35A1.1,1.1,0,0,1,232.856,294.013Z",
    transform: "translate(-225.179 -287.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8578",
    "data-name": "Path 8578",
    d: "M251.172,346.418c-.057.033-.1.049-.106.042l-.1-.073-.082-.067-.085.091c-.185.2-.189.21-.246.213-.085.009-.1-.006-.207-.161-.055-.079-.1-.146-.1-.146s-.04-.006-.085-.009l-.085-.009-.04.082-.039.082-.07-.021a1.437,1.437,0,0,1-.161-.063l-.091-.045v-.173l.808,0,.808,0,0,.082C251.3,346.345,251.305,346.339,251.172,346.418Z",
    transform: "translate(-245.099 -339.28)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8579",
    "data-name": "Path 8579",
    d: "M142.488,269.806c0-.012,0-.033-.006-.067a6.464,6.464,0,0,0-4.744,1.468,3.681,3.681,0,0,0-3.541-2.857,4.53,4.53,0,0,0-4,2.857,5.252,5.252,0,0,0-4.613-1.516v.058a2.6,2.6,0,0,0,.063.927,5.907,5.907,0,0,0,2.025,2.76,11.706,11.706,0,0,0,6.1,2.765,10.587,10.587,0,0,0,6.674-2.644,9.435,9.435,0,0,0,.839-.842,4.6,4.6,0,0,0,.447-.6c-.006,0,0-.006.012-.012s.018-.015.012-.021,0-.012.013-.015.015-.009.012-.015,0-.012.012-.015a.014.014,0,0,0,.009-.007.014.014,0,0,0,0-.011.008.008,0,0,1,.006-.012c.006,0,.012-.009.012-.015s.006-.015.013-.015a.013.013,0,0,0,.012-.013.3.3,0,0,1,.04-.069c.045-.07.228-.4.252-.45a4.189,4.189,0,0,0,.334-1.091,3.708,3.708,0,0,0,.021-.55Zm-7.6,3.708c-.057.033-.1.049-.106.042l-.1-.073-.082-.067-.085.091c-.185.2-.189.21-.246.213-.085.009-.1-.006-.207-.161-.055-.079-.1-.146-.1-.146s-.04-.006-.085-.009l-.085-.009-.04.082-.039.082-.07-.021a1.422,1.422,0,0,1-.161-.063l-.091-.045v-.173l.808,0,.808,0,0,.082C135.021,273.441,135.024,273.435,134.89,273.514Zm1.52-.547c-.045.173-.082.315-.082.319a.5.5,0,0,1-.1,0h-.1l-.13.319c-.073.173-.139.334-.149.359l-.018.042-.063-.1-.063-.1v-.842l-.025.006c-.052.012-.419.063-.58.076a8.262,8.262,0,0,1-2-.043,1.95,1.95,0,0,0-.2-.024s0,.2.006.438l.009.431-.052.079c-.027.043-.055.079-.055.083a.676.676,0,0,1-.109-.18,2.019,2.019,0,0,1-.17-.462l-.021-.088-.094.006-.095.009-.024-.112c-.013-.063-.028-.155-.033-.207l-.009-.1-.081-.071c-.046-.04-.091-.079-.1-.085a.067.067,0,0,1-.021-.052v-.037l.378,0,.378,0,.012.039.013.04.131.006.511.015.378.009.1-.152.1-.152h.126v-.315l0-.315-.167-.073a1.63,1.63,0,0,1-.972-.836,1.151,1.151,0,0,1-.031-.395,1.186,1.186,0,0,1,.018-.4.441.441,0,0,1,.315-.31,7.287,7.287,0,0,1,.905-.015l.845,0,.095.045a.529.529,0,0,1,.228.18.5.5,0,0,1,.095.359,2.647,2.647,0,0,1-.046.583,1.246,1.246,0,0,1-.176.349,1.619,1.619,0,0,1-.681.477l-.073.027,0,.32,0,.319.067.006.067.006.091.137.088.137h.407c.225,0,.422,0,.441.006s.037,0,.067-.049l.037-.054h.35a1.285,1.285,0,0,1,.349.012A2.069,2.069,0,0,0,136.41,272.967Z",
    transform: "translate(-125.274 -257.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8580",
    "data-name": "Path 8580",
    d: "M121.134,289.61a2.726,2.726,0,0,0-.3.058",
    transform: "translate(-120.83 -277.691)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8581",
    "data-name": "Path 8581",
    d: "M393.98,290.41a2.713,2.713,0,0,0-.27-.04",
    transform: "translate(-376.505 -278.403)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8582",
    "data-name": "Path 8582",
    d: "M142.545,112.3c-.006-.137-.018-.328-.027-.422a8.923,8.923,0,0,0-1.152-3.7,1.112,1.112,0,0,1-.067-.126.122.122,0,0,1-.012-.024h0c.094-.285.48-1.467.787-2.821.416-1.835.681-3.981-.126-4.625,0,0-1.4-.1-3.27,1.732a12.6,12.6,0,0,0-1.387,1.644l-.131-.042a9.474,9.474,0,0,0-2.322-.45c-.237-.018-1.121-.018-1.41,0a8.2,8.2,0,0,0-2.3.453c-.03.012-.058.021-.085.03a12.432,12.432,0,0,0-1.431-1.632c-1.948-1.845-3.4-1.738-3.4-1.738-.857.666-.567,2.909-.122,4.805.292,1.255.65,2.358.784,2.757a.6.6,0,0,1-.033.067,11.024,11.024,0,0,0-1.182,4.287,5.25,5.25,0,0,1,4.617,1.516,4.532,4.532,0,0,1,4-2.857,3.682,3.682,0,0,1,3.541,2.857,6.48,6.48,0,0,1,4.744-1.468C142.557,112.479,142.551,112.389,142.545,112.3Zm-15.1-5.306s-1.135-2.842-.845-4.465h0a1.568,1.568,0,0,1,.283-.694s1.288.126,3.367,2.438a5.926,5.926,0,0,0-.924.6l-.006,0A7.313,7.313,0,0,0,127.447,106.99Zm4.823,4.221a.33.33,0,0,1-.212.091,3.43,3.43,0,0,1-.6-.015,6.287,6.287,0,0,1-1.828-.526,2.3,2.3,0,0,1-.631-.422l-.085-.088-.009-.116a3.206,3.206,0,0,1,.012-.631.82.82,0,0,1,.095-.268c.024-.03.024-.03.134-.03a1.308,1.308,0,0,1,.428.079,8.353,8.353,0,0,1,1.608.8,2.788,2.788,0,0,1,.93.723c.115.142.19.339.161.4Zm7.16-1.009a1.017,1.017,0,0,1-.294.3,5.08,5.08,0,0,1-1.933.729,2.374,2.374,0,0,1-1,.028c-.085-.043-.1-.076-.067-.185a1.472,1.472,0,0,1,.593-.711c.164-.119.83-.523,1.14-.694a4.026,4.026,0,0,1,1.2-.487.622.622,0,0,1,.228,0c.055.021.115.183.14.378a5,5,0,0,1-.007.643Zm-.5-5.34h-.006a5.7,5.7,0,0,0-.894-.6c2.009-2.31,3.252-2.438,3.252-2.438a1.647,1.647,0,0,1,.274.694h0c.282,1.623-.815,4.468-.815,4.468a7.239,7.239,0,0,0-1.811-2.125Z",
    transform: "translate(-125.355 -100.572)",
    fill: "#ffa409"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8583",
    "data-name": "Path 8583",
    d: "M309.845,154.21c-.006.006-.009.015-.015.021",
    transform: "translate(-297.914 -150.828)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8584",
    "data-name": "Path 8584",
    d: "M373.141,218.66c-.015.042-.021.063-.021.063",
    transform: "translate(-357.213 -211.215)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934",
    transform: "translate(12.673 1.258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8585",
    "data-name": "Path 8585",
    d: "M325.359,121.213c-.237-.03-1.359-.037-2.629,2.343h-.006a5.7,5.7,0,0,0-.894-.6c2.009-2.31,3.252-2.437,3.252-2.437A1.617,1.617,0,0,1,325.359,121.213Z",
    transform: "translate(-321.83 -120.52)",
    fill: "#ff9300"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8586",
    "data-name": "Path 8586",
    d: "M337.915,135.881a7.219,7.219,0,0,0-1.815-2.125c1.27-2.38,2.39-2.375,2.629-2.343h0C339.012,133.04,337.915,135.881,337.915,135.881Z",
    transform: "translate(-335.2 -130.721)",
    fill: "#ff8300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8587",
    "data-name": "Path 8587",
    d: "M377.845,131.519l-.045-.009Z",
    transform: "translate(-374.271 -130.817)",
    fill: "#ff8300"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8588",
    "data-name": "Path 8588",
    d: "M211.064,154.216c-.03-.042-.063-.085-.094-.126",
    transform: "translate(-205.287 -150.716)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8589",
    "data-name": "Path 8589",
    d: "M144.93,220.54c.033.1.055.158.055.158",
    transform: "translate(-143.41 -212.976)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937",
    transform: "translate(1.199 1.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935",
    transform: "translate(0.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8590",
    "data-name": "Path 8590",
    d: "M144.252,122.9a5.99,5.99,0,0,0-.924.6h-.006c-1.316-2.383-2.473-2.373-2.723-2.343a1.561,1.561,0,0,1,.282-.694S142.174,120.589,144.252,122.9Z",
    transform: "translate(-140.6 -120.46)",
    fill: "#ff9300"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8591",
    "data-name": "Path 8591",
    d: "M142.621,133.757a7.289,7.289,0,0,0-1.881,2.125s-1.135-2.842-.845-4.468h0C140.144,131.381,141.308,131.377,142.621,133.757Z",
    transform: "translate(-139.848 -130.717)",
    fill: "#ff8300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8592",
    "data-name": "Path 8592",
    d: "M139.919,131.51l-.049.009Z",
    transform: "translate(-139.869 -130.813)",
    fill: "#ff8300"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8593",
    "data-name": "Path 8593",
    d: "M303.295,204.74s-.973.063-.851-.7a1,1,0,0,1,1.094-.82c.211.032,1.064.334.912.973s-.364.516-.486.547A4.8,4.8,0,0,1,303.295,204.74Z",
    transform: "translate(-290.983 -196.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8594",
    "data-name": "Path 8594",
    d: "M189.544,204.74s-.972.063-.851-.7a1,1,0,0,1,1.094-.82c.211.032,1.064.334.912.973s-.365.516-.486.547A4.806,4.806,0,0,1,189.544,204.74Z",
    transform: "translate(-184.405 -196.744)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShibaInu);
export default __webpack_public_path__ + "static/media/shiba-inu.1475228a7550f896996a65e407a6fc99.svg";
export { ForwardRef as ReactComponent };